import {Inject, ISimpleControllerConfiguration, SimpleBaseController,} from "@denishussar/html5-game-engine";
import {BussinesTripModel, BussinesTripRouteType} from "../Models/BussinesTripModel";
import {BussinesTripLogic} from "../Logic/BussinesTripLogic";
import {BussinesTripController} from "./BussinesTripController";
import {GameLogic} from "../../../../../Logic/GameLogic";
import {MiniGameTypeEnum} from "../../../../../Models/Game/MiniGameModel";

export class BussinesTripRootController extends SimpleBaseController {
    $model: BussinesTripModel;

    public constructor(
        @Inject private _options: any,
        @Inject private _gameLogic: GameLogic,
        @Inject private _logic: BussinesTripLogic,
    ) {
        super('BussinesTripRootController');
    }

    protected getConfiguration(): ISimpleControllerConfiguration {
        return {};
    }

    protected onInitialize(): void {
        const types = [BussinesTripRouteType.A, BussinesTripRouteType.B];
        this.showCities(types[Math.floor(Math.random() * types.length)]);
    }

    protected onDestroy() {
        super.onDestroy();

        this.removeChildControllerByName('BussinesTripController');
    }

    private showCities(routeType: string): void {
        this._logic.setRouteType(routeType as BussinesTripRouteType);

        this.addChildController({
            view: BussinesTripController,
            model: this.$model,
            options: {
                name: name,
                onComplete: () => this._gameLogic.onMiniGameComplete(MiniGameTypeEnum.bussines_trip),
                onFail: () => this._gameLogic.onMiniGameFail(MiniGameTypeEnum.bussines_trip)
            }
        }, 'BussinesTripController');
    }
}
